/*****************************************************************
 * DO NOT MANUALLY EDIT THIS FILE!                               *
 *                                                               *
 * This file is auto-generated by 'yarn prepare'                 *
 *****************************************************************/
import * as datastoreCollections from '@freelancer/datastore/collections';
import * as documentCreators from './document-creators';
import * as pushTransformers from './push-transformers';

export const datastoreFunctions = {
  abnDetailsBackend: datastoreCollections.abnDetailsBackend,
  academicWritingLevel1Exam: datastoreCollections.academicWritingLevel1Exam,
  acceptDocumentFileFormats: datastoreCollections.acceptDocumentFileFormats,
  acceptedBid: datastoreCollections.acceptedBid,
  accountProgressEmailVerify: datastoreCollections.accountProgressEmailVerify,
  accountProgressPaymentVerify:
    datastoreCollections.accountProgressPaymentVerify,
  accountingSkill: datastoreCollections.accountingSkill,
  active: datastoreCollections.active,
  activeCorporation: datastoreCollections.activeCorporation,
  activeEntry: datastoreCollections.activeEntry,
  activeHourlyContract: datastoreCollections.activeHourlyContract,
  activeNewsfeedGroup: datastoreCollections.activeNewsfeedGroup,
  activeServiceOffering: datastoreCollections.activeServiceOffering,
  activeUserSanction: datastoreCollections.activeUserSanction,
  adminPermissions: datastoreCollections.adminPermissions,
  adobeFlashSkill: datastoreCollections.adobeFlashSkill,
  adobePhotoShopCs5Level1Exam: datastoreCollections.adobePhotoShopCs5Level1Exam,
  aiAutoReplyDisabled: datastoreCollections.aiAutoReplyDisabled,
  aiAutoReplyEnabled: datastoreCollections.aiAutoReplyEnabled,
  aiAutoReplyUnset: datastoreCollections.aiAutoReplyUnset,
  aiFeaturesBenefit: datastoreCollections.aiFeaturesBenefit,
  analyticsViewerGrant: datastoreCollections.analyticsViewerGrant,
  androidLevel1Exam: datastoreCollections.androidLevel1Exam,
  androidSkill: datastoreCollections.androidSkill,
  annotationContestComment: datastoreCollections.annotationContestComment,
  anotherTalentNetworkAdminPool:
    datastoreCollections.anotherTalentNetworkAdminPool,
  anotherTalentNetworkPool: datastoreCollections.anotherTalentNetworkPool,
  approvedKycRequest: datastoreCollections.approvedKycRequest,
  approvedQuotation: datastoreCollections.approvedQuotation,
  articleWritingSkill: datastoreCollections.articleWritingSkill,
  asapDeliveryProject: datastoreCollections.asapDeliveryProject,
  attachedToQuotation: datastoreCollections.attachedToQuotation,
  audienceExternal: datastoreCollections.audienceExternal,
  audienceInternalOnly: datastoreCollections.audienceInternalOnly,
  australianHourlyProjectFees: datastoreCollections.australianHourlyProjectFees,
  australianSalesTax: datastoreCollections.australianSalesTax,
  australianUser: datastoreCollections.australianUser,
  autoBillingOffHourlyContract:
    datastoreCollections.autoBillingOffHourlyContract,
  autoBillingOnHourlyContract: datastoreCollections.autoBillingOnHourlyContract,
  averageTimeToAwardMetric: datastoreCollections.averageTimeToAwardMetric,
  awardAndChatCollaborator: datastoreCollections.awardAndChatCollaborator,
  awardProjectRichMessage: datastoreCollections.awardProjectRichMessage,
  awardedBid: datastoreCollections.awardedBid,
  awardedEntry: datastoreCollections.awardedEntry,
  awardedProject: datastoreCollections.awardedProject,
  bDoubleVehicleType: datastoreCollections.bDoubleVehicleType,
  bTripleVehicleType: datastoreCollections.bTripleVehicleType,
  bannersManagementGrant: datastoreCollections.bannersManagementGrant,
  bidOnPremiumProjectBenefit: datastoreCollections.bidOnPremiumProjectBenefit,
  bidStatsFromBids: datastoreCollections.bidStatsFromBids,
  bidToProjectViewBidTransformer:
    datastoreCollections.bidToProjectViewBidTransformer,
  biddingCompleteUserProfile: datastoreCollections.biddingCompleteUserProfile,
  bidsDigestEmailBody: datastoreCollections.bidsDigestEmailBody,
  bidsDigestEmailSubject: datastoreCollections.bidsDigestEmailSubject,
  bidsFromProject: datastoreCollections.bidsFromProject,
  billableMetric: datastoreCollections.billableMetric,
  billingInterval: datastoreCollections.billingInterval,
  boughtEntry: datastoreCollections.boughtEntry,
  buyerConfirmedContestHandover:
    datastoreCollections.buyerConfirmedContestHandover,
  buyerSignedContestHandover: datastoreCollections.buyerSignedContestHandover,
  californianUser: datastoreCollections.californianUser,
  campaignsBackend: datastoreCollections.campaignsBackend,
  canViewEmployerProfileFromUser:
    datastoreCollections.canViewEmployerProfileFromUser,
  canceledBid: datastoreCollections.canceledBid,
  canceledMilestone: datastoreCollections.canceledMilestone,
  cancelledKycRequest: datastoreCollections.cancelledKycRequest,
  cancelledProject: datastoreCollections.cancelledProject,
  cancelledQuotation: datastoreCollections.cancelledQuotation,
  carSkill: datastoreCollections.carSkill,
  cartForProject: datastoreCollections.cartForProject,
  cartItemFromMilestoneDraft: datastoreCollections.cartItemFromMilestoneDraft,
  certifications: datastoreCollections.certifications,
  clearedMilestone: datastoreCollections.clearedMilestone,
  clientEngagementBenefit: datastoreCollections.clientEngagementBenefit,
  clientsCollection: datastoreCollections.clientsCollection,
  closedContest: datastoreCollections.closedContest,
  closedProject: datastoreCollections.closedProject,
  collaborationInvitationEmailBody:
    datastoreCollections.collaborationInvitationEmailBody,
  collaborationInvitationEmailSubject:
    datastoreCollections.collaborationInvitationEmailSubject,
  colleagueAwardedProjectEmailBody:
    datastoreCollections.colleagueAwardedProjectEmailBody,
  colleagueAwardedProjectEmailSubject:
    datastoreCollections.colleagueAwardedProjectEmailSubject,
  completeHandoverByClient: datastoreCollections.completeHandoverByClient,
  completeHandoverByFreelancer:
    datastoreCollections.completeHandoverByFreelancer,
  completeItem: datastoreCollections.completeItem,
  completeProject: datastoreCollections.completeProject,
  complianceQueueAgentDigestEmailBody:
    datastoreCollections.complianceQueueAgentDigestEmailBody,
  complianceQueueAgentDigestEmailSubject:
    datastoreCollections.complianceQueueAgentDigestEmailSubject,
  contestAcceptOfferEmployerRichMessage:
    datastoreCollections.contestAcceptOfferEmployerRichMessage,
  contestAcceptOfferFreelancerRichMessage:
    datastoreCollections.contestAcceptOfferFreelancerRichMessage,
  contestContext: datastoreCollections.contestContext,
  contestIpContract: datastoreCollections.contestIpContract,
  contestSource: datastoreCollections.contestSource,
  copywritingSkill: datastoreCollections.copywritingSkill,
  countryAlignment: datastoreCollections.countryAlignment,
  craneType: datastoreCollections.craneType,
  createBidRankSortKey: datastoreCollections.createBidRankSortKey,
  createBooleanBidRankSortKey: datastoreCollections.createBooleanBidRankSortKey,
  createCanvasRichMessage: datastoreCollections.createCanvasRichMessage,
  createCustomerSatisfactionFeedbackRichMessage:
    datastoreCollections.createCustomerSatisfactionFeedbackRichMessage,
  createExternalCredentialRichMessage:
    datastoreCollections.createExternalCredentialRichMessage,
  createFreightlancerConciergeOutOfOfficeRichMessage:
    datastoreCollections.createFreightlancerConciergeOutOfOfficeRichMessage,
  createMilestoneReleaseReminderRichMessage:
    datastoreCollections.createMilestoneReleaseReminderRichMessage,
  createMilestoneReleaseRequestRichMessage:
    datastoreCollections.createMilestoneReleaseRequestRichMessage,
  createNumberBidRankSortKey: datastoreCollections.createNumberBidRankSortKey,
  createObjectCustomFields: datastoreCollections.createObjectCustomFields,
  createSimilarSkillsArray: datastoreCollections.createSimilarSkillsArray,
  createdMilestoneRequest: datastoreCollections.createdMilestoneRequest,
  cryptocurrencyProject: datastoreCollections.cryptocurrencyProject,
  cryptocurrencySkill: datastoreCollections.cryptocurrencySkill,
  currencyCodeFromId: datastoreCollections.currencyCodeFromId,
  currencyForPublicLiability: datastoreCollections.currencyForPublicLiability,
  currencyUSD: datastoreCollections.currencyUSD,
  curtainSiderVehicleType: datastoreCollections.curtainSiderVehicleType,
  customBudget: datastoreCollections.customBudget,
  customFieldRelationshipsBackend:
    datastoreCollections.customFieldRelationshipsBackend,
  customFieldRelationshipsReducer:
    datastoreCollections.customFieldRelationshipsReducer,
  dataEntryExam: datastoreCollections.dataEntryExam,
  dataEntryProfile: datastoreCollections.dataEntryProfile,
  dataEntrySkill: datastoreCollections.dataEntrySkill,
  dataProcessingSkill: datastoreCollections.dataProcessingSkill,
  decodeThreadId: datastoreCollections.decodeThreadId,
  defaultProfile: datastoreCollections.defaultProfile,
  deletePermission: datastoreCollections.deletePermission,
  deletedEntry: datastoreCollections.deletedEntry,
  deletedItem: datastoreCollections.deletedItem,
  deliveryContactsSensitiveDetailsBackend:
    datastoreCollections.deliveryContactsSensitiveDetailsBackend,
  deliveryItemLarge: datastoreCollections.deliveryItemLarge,
  deliveryItemOversized: datastoreCollections.deliveryItemOversized,
  deliveryItemSmall: datastoreCollections.deliveryItemSmall,
  deliveryItemWithSkillAnswer: datastoreCollections.deliveryItemWithSkillAnswer,
  deliveryProject: datastoreCollections.deliveryProject,
  deliverySkill: datastoreCollections.deliverySkill,
  deloitteAdminPool: datastoreCollections.deloitteAdminPool,
  deloitteBidRestriction: datastoreCollections.deloitteBidRestriction,
  deloitteEnterprise: datastoreCollections.deloitteEnterprise,
  deloitteFTNUser: datastoreCollections.deloitteFTNUser,
  deloitteFtnPool: datastoreCollections.deloitteFtnPool,
  deloitteInternalGroup: datastoreCollections.deloitteInternalGroup,
  deloitteInternalProject: datastoreCollections.deloitteInternalProject,
  deloitteLinkedExternalProject:
    datastoreCollections.deloitteLinkedExternalProject,
  deloitteOnBehalfProject: datastoreCollections.deloitteOnBehalfProject,
  deloittePool: datastoreCollections.deloittePool,
  deloitteProjectUpgrades: datastoreCollections.deloitteProjectUpgrades,
  deloitteUser: datastoreCollections.deloitteUser,
  deloitteUserWithCustomFields:
    datastoreCollections.deloitteUserWithCustomFields,
  disputedMilestone: datastoreCollections.disputedMilestone,
  doGooderBadge: datastoreCollections.doGooderBadge,
  documentType: datastoreCollections.documentType,
  documentTypeFiles: datastoreCollections.documentTypeFiles,
  draftEntry: datastoreCollections.draftEntry,
  draftQuotation: datastoreCollections.draftQuotation,
  draftServiceOffering: datastoreCollections.draftServiceOffering,
  driversLicense: datastoreCollections.driversLicense,
  emailAddress: datastoreCollections.emailAddress,
  emailUnverifiedUser: datastoreCollections.emailUnverifiedUser,
  employerFollowBenefit: datastoreCollections.employerFollowBenefit,
  employerUser: datastoreCollections.employerUser,
  encodeThreadId: datastoreCollections.encodeThreadId,
  encodedUrlForUserProfile: datastoreCollections.encodedUrlForUserProfile,
  enterpriseBenefit: datastoreCollections.enterpriseBenefit,
  enterpriseUpgrade: datastoreCollections.enterpriseUpgrade,
  errorDocumentSubmissionNote: datastoreCollections.errorDocumentSubmissionNote,
  escrowProfileCompleteUserSelf:
    datastoreCollections.escrowProfileCompleteUserSelf,
  estimateDeliveryProject: datastoreCollections.estimateDeliveryProject,
  expiredProject: datastoreCollections.expiredProject,
  expiredQuotation: datastoreCollections.expiredQuotation,
  externalProjectsAwardedMetric:
    datastoreCollections.externalProjectsAwardedMetric,
  externalQuotation: datastoreCollections.externalQuotation,
  facebookAdminEnterprise: datastoreCollections.facebookAdminEnterprise,
  facebookAdminPool: datastoreCollections.facebookAdminPool,
  facebookCertifiedUser: datastoreCollections.facebookCertifiedUser,
  facebookEnterprise: datastoreCollections.facebookEnterprise,
  facebookPool: datastoreCollections.facebookPool,
  facebookProject: datastoreCollections.facebookProject,
  facebookUser: datastoreCollections.facebookUser,
  feedForContestUpdates: datastoreCollections.feedForContestUpdates,
  feedForGroup: datastoreCollections.feedForGroup,
  feedForPost: datastoreCollections.feedForPost,
  feedPostFileAttachments: datastoreCollections.feedPostFileAttachments,
  feedPostToFeedItemTransformer:
    datastoreCollections.feedPostToFeedItemTransformer,
  firstName: datastoreCollections.firstName,
  fixedProject: datastoreCollections.fixedProject,
  fixedTokenProject: datastoreCollections.fixedTokenProject,
  fixedUsdProject: datastoreCollections.fixedUsdProject,
  flnltdPool: datastoreCollections.flnltdPool,
  floatVehicleType: datastoreCollections.floatVehicleType,
  forContest: datastoreCollections.forContest,
  forContestNps: datastoreCollections.forContestNps,
  forEnterprise: datastoreCollections.forEnterprise,
  forInvoice: datastoreCollections.forInvoice,
  forProject: datastoreCollections.forProject,
  forProjectNps: datastoreCollections.forProjectNps,
  forReviewContestHandover: datastoreCollections.forReviewContestHandover,
  forkliftType: datastoreCollections.forkliftType,
  formattedBillingFrequency: datastoreCollections.formattedBillingFrequency,
  foundationShareholderBadge: datastoreCollections.foundationShareholderBadge,
  freelancerAdminPool: datastoreCollections.freelancerAdminPool,
  freelancerPool: datastoreCollections.freelancerPool,
  freelancerUnverifiedUser: datastoreCollections.freelancerUnverifiedUser,
  freelancerUser: datastoreCollections.freelancerUser,
  freelancerVideoVerification: datastoreCollections.freelancerVideoVerification,
  freightLoad: datastoreCollections.freightLoad,
  freightSkill: datastoreCollections.freightSkill,
  freightlancerAdminEnterprise:
    datastoreCollections.freightlancerAdminEnterprise,
  freightlancerEnterprise: datastoreCollections.freightlancerEnterprise,
  freightlancerPool: datastoreCollections.freightlancerPool,
  fromAlberta: datastoreCollections.fromAlberta,
  fromContest: datastoreCollections.fromContest,
  fromDelhi: datastoreCollections.fromDelhi,
  fromDhaka: datastoreCollections.fromDhaka,
  fromEmployerNps: datastoreCollections.fromEmployerNps,
  fromInternalProject: datastoreCollections.fromInternalProject,
  fromKarachi: datastoreCollections.fromKarachi,
  fromKualaLumpur: datastoreCollections.fromKualaLumpur,
  fromMelbourne: datastoreCollections.fromMelbourne,
  fromMumbai: datastoreCollections.fromMumbai,
  fromRome: datastoreCollections.fromRome,
  fromSeattle: datastoreCollections.fromSeattle,
  fromServiceOffering: datastoreCollections.fromServiceOffering,
  fromSkill: datastoreCollections.fromSkill,
  fromSydney: datastoreCollections.fromSydney,
  fromVaticanCity: datastoreCollections.fromVaticanCity,
  frozenMilestone: datastoreCollections.frozenMilestone,
  fullyPaidBidMilestone: datastoreCollections.fullyPaidBidMilestone,
  fullyPaidCompleteBid: datastoreCollections.fullyPaidCompleteBid,
  fundingRequiredEmailBody: datastoreCollections.fundingRequiredEmailBody,
  fundingRequiredEmailSubject: datastoreCollections.fundingRequiredEmailSubject,
  generalFullLoadSkill: datastoreCollections.generalFullLoadSkill,
  getActiveLanguages: datastoreCollections.getActiveLanguages,
  getCustomFieldInfoConfigurationOptions:
    datastoreCollections.getCustomFieldInfoConfigurationOptions,
  getCustomFieldValues: datastoreCollections.getCustomFieldValues,
  getCustomFieldsAndValues: datastoreCollections.getCustomFieldsAndValues,
  getDefaultGroupPermissions: datastoreCollections.getDefaultGroupPermissions,
  getDeloitteProjectCustomFieldsAndValues:
    datastoreCollections.getDeloitteProjectCustomFieldsAndValues,
  getGroupOrderByFeedReadLatestTimeInMs:
    datastoreCollections.getGroupOrderByFeedReadLatestTimeInMs,
  getHirePageDetailsResultObject:
    datastoreCollections.getHirePageDetailsResultObject,
  getHpisEngineerNote: datastoreCollections.getHpisEngineerNote,
  getHpisPartOrder: datastoreCollections.getHpisPartOrder,
  getHpisProjectCustomFieldsAndValues:
    datastoreCollections.getHpisProjectCustomFieldsAndValues,
  getHpisTimeLog: datastoreCollections.getHpisTimeLog,
  getLanguages: datastoreCollections.getLanguages,
  getLocationPresets: datastoreCollections.getLocationPresets,
  getPriceTier: datastoreCollections.getPriceTier,
  getProjectViewUserLocations: datastoreCollections.getProjectViewUserLocations,
  getTaskSectionPresets: datastoreCollections.getTaskSectionPresets,
  getUsStates: datastoreCollections.getUsStates,
  getUserSettingId: datastoreCollections.getUserSettingId,
  getWebsiteBuildShowCase: datastoreCollections.getWebsiteBuildShowCase,
  grantEnterprise: datastoreCollections.grantEnterprise,
  grantPool: datastoreCollections.grantPool,
  graphicDesignProfile: datastoreCollections.graphicDesignProfile,
  graphicDesignSkill: datastoreCollections.graphicDesignSkill,
  groupActionsTransformers: datastoreCollections.groupActionsTransformers,
  groupAdmin: datastoreCollections.groupAdmin,
  groupAdmins: datastoreCollections.groupAdmins,
  groupFeedCollection: datastoreCollections.groupFeedCollection,
  groupFeedMeta: datastoreCollections.groupFeedMeta,
  groupGuest: datastoreCollections.groupGuest,
  groupGuests: datastoreCollections.groupGuests,
  groupMember: datastoreCollections.groupMember,
  groupMemberFeedPost: datastoreCollections.groupMemberFeedPost,
  groupMembers: datastoreCollections.groupMembers,
  groupModerator: datastoreCollections.groupModerator,
  groupModerators: datastoreCollections.groupModerators,
  groupMuted: datastoreCollections.groupMuted,
  groupMutedMembers: datastoreCollections.groupMutedMembers,
  groupsManagementBackendGrant:
    datastoreCollections.groupsManagementBackendGrant,
  groupsManagementGrant: datastoreCollections.groupsManagementGrant,
  guaranteedUpgrade: datastoreCollections.guaranteedUpgrade,
  guestPermissions: datastoreCollections.guestPermissions,
  handoverAwaitingBuyerConfirmation:
    datastoreCollections.handoverAwaitingBuyerConfirmation,
  handoverAwaitingBuyerSignature:
    datastoreCollections.handoverAwaitingBuyerSignature,
  handoverAwaitingFreelancerSignature:
    datastoreCollections.handoverAwaitingFreelancerSignature,
  handoverAwaitingFreelancerUpload:
    datastoreCollections.handoverAwaitingFreelancerUpload,
  handoverBothConfirmed: datastoreCollections.handoverBothConfirmed,
  handoverEntryAwarded: datastoreCollections.handoverEntryAwarded,
  haySkill: datastoreCollections.haySkill,
  heygenPool: datastoreCollections.heygenPool,
  heygenSkill: datastoreCollections.heygenSkill,
  hiddenServiceOffering: datastoreCollections.hiddenServiceOffering,
  highlightEntry: datastoreCollections.highlightEntry,
  hiresCollection: datastoreCollections.hiresCollection,
  hourlyContractFromBid: datastoreCollections.hourlyContractFromBid,
  hourlyUsdProject: datastoreCollections.hourlyUsdProject,
  hoursPostedCumulativeSumMetric:
    datastoreCollections.hoursPostedCumulativeSumMetric,
  hoursPostedMetric: datastoreCollections.hoursPostedMetric,
  hpDispatcherGrant: datastoreCollections.hpDispatcherGrant,
  hpEnterprise: datastoreCollections.hpEnterprise,
  hpPool: datastoreCollections.hpPool,
  hpProject: datastoreCollections.hpProject,
  hpUser: datastoreCollections.hpUser,
  idDetailsOnly: datastoreCollections.idDetailsOnly,
  identityVerifiedUser: datastoreCollections.identityVerifiedUser,
  imageContestFile: datastoreCollections.imageContestFile,
  inReview: datastoreCollections.inReview,
  inReviewGroup: datastoreCollections.inReviewGroup,
  inactiveHourlyContract: datastoreCollections.inactiveHourlyContract,
  incompleteAtoSerrEntryRequirements:
    datastoreCollections.incompleteAtoSerrEntryRequirements,
  incompleteBid: datastoreCollections.incompleteBid,
  incompleteEntryRequirements: datastoreCollections.incompleteEntryRequirements,
  incompleteHirePageDetailsResult:
    datastoreCollections.incompleteHirePageDetailsResult,
  incompleteKycRequest: datastoreCollections.incompleteKycRequest,
  incompleteProject: datastoreCollections.incompleteProject,
  independenceRuleset: datastoreCollections.independenceRuleset,
  infoDocumentSubmissionNote: datastoreCollections.infoDocumentSubmissionNote,
  initialPayment: datastoreCollections.initialPayment,
  insourceEnterprise: datastoreCollections.insourceEnterprise,
  insourceOnlyPool: datastoreCollections.insourceOnlyPool,
  insourceUser: datastoreCollections.insourceUser,
  insuranceVerification: datastoreCollections.insuranceVerification,
  internalUserSkillsMetric: datastoreCollections.internalUserSkillsMetric,
  invalidItem: datastoreCollections.invalidItem,
  invalidQuotation: datastoreCollections.invalidQuotation,
  invertBooleanString: datastoreCollections.invertBooleanString,
  invertNumberString: datastoreCollections.invertNumberString,
  invitationBlocksBackend: datastoreCollections.invitationBlocksBackend,
  invitationsBackend: datastoreCollections.invitationsBackend,
  isAppPlatformType: datastoreCollections.isAppPlatformType,
  isAttachment: datastoreCollections.isAttachment,
  isChallengeContestElement: datastoreCollections.isChallengeContestElement,
  isChallengeElement: datastoreCollections.isChallengeElement,
  isChallengeUiPropertyTypeApi:
    datastoreCollections.isChallengeUiPropertyTypeApi,
  isCountry: datastoreCollections.isCountry,
  isNewsfeedEntry: datastoreCollections.isNewsfeedEntry,
  isNotificationEntry: datastoreCollections.isNotificationEntry,
  isSearchSavedFiltersChallenge:
    datastoreCollections.isSearchSavedFiltersChallenge,
  isSearchSavedFiltersContest: datastoreCollections.isSearchSavedFiltersContest,
  isSearchSavedFiltersLoad: datastoreCollections.isSearchSavedFiltersLoad,
  isSearchSavedFiltersProject: datastoreCollections.isSearchSavedFiltersProject,
  isSearchSavedFiltersUser: datastoreCollections.isSearchSavedFiltersUser,
  isTestEntry: datastoreCollections.isTestEntry,
  javaScriptLevel1Exam: datastoreCollections.javaScriptLevel1Exam,
  javaScriptSkill: datastoreCollections.javaScriptSkill,
  javaSkill: datastoreCollections.javaSkill,
  largeBudgetNonPremiumProject:
    datastoreCollections.largeBudgetNonPremiumProject,
  largeItem: datastoreCollections.largeItem,
  lastName: datastoreCollections.lastName,
  legalEntityAlignment: datastoreCollections.legalEntityAlignment,
  level: datastoreCollections.level,
  linkCustomCta: datastoreCollections.linkCustomCta,
  linkedExternalProject: datastoreCollections.linkedExternalProject,
  linkedInternalProject: datastoreCollections.linkedInternalProject,
  linkedToProject: datastoreCollections.linkedToProject,
  linuxSkill: datastoreCollections.linuxSkill,
  listsFavoritesCollection: datastoreCollections.listsFavoritesCollection,
  loadingFacilitiesGroup: datastoreCollections.loadingFacilitiesGroup,
  loadshiftCarrierVerification:
    datastoreCollections.loadshiftCarrierVerification,
  loadshiftSupportGrant: datastoreCollections.loadshiftSupportGrant,
  loadshiftUser: datastoreCollections.loadshiftUser,
  localProject: datastoreCollections.localProject,
  locationBondiNSW: datastoreCollections.locationBondiNSW,
  locationBrisbaneQLD: datastoreCollections.locationBrisbaneQLD,
  locationDubboNSW: datastoreCollections.locationDubboNSW,
  locationMelbourneVIC: datastoreCollections.locationMelbourneVIC,
  locationPortArthurTAS: datastoreCollections.locationPortArthurTAS,
  locationRegencyParkSA: datastoreCollections.locationRegencyParkSA,
  locationWynyardNSW: datastoreCollections.locationWynyardNSW,
  logoDesignSkill: datastoreCollections.logoDesignSkill,
  machineryMobile: datastoreCollections.machineryMobile,
  machinerySkill: datastoreCollections.machinerySkill,
  manageEmailContentGrant: datastoreCollections.manageEmailContentGrant,
  meanBidAmountMetric: datastoreCollections.meanBidAmountMetric,
  medianBidAmountMetric: datastoreCollections.medianBidAmountMetric,
  medianBidCountMetric: datastoreCollections.medianBidCountMetric,
  mediumItem: datastoreCollections.mediumItem,
  memberFee: datastoreCollections.memberFee,
  memberFirmAlignment: datastoreCollections.memberFirmAlignment,
  memberPermissions: datastoreCollections.memberPermissions,
  mentionedProjectTextEntity: datastoreCollections.mentionedProjectTextEntity,
  mentionedUserTextEntityContent:
    datastoreCollections.mentionedUserTextEntityContent,
  mfaEmailAndPhoneDetails: datastoreCollections.mfaEmailAndPhoneDetails,
  mfaEmailOnly: datastoreCollections.mfaEmailOnly,
  milestoneDraftFromBid: datastoreCollections.milestoneDraftFromBid,
  milestoneFromBid: datastoreCollections.milestoneFromBid,
  milestoneFromQuotationItemRevision:
    datastoreCollections.milestoneFromQuotationItemRevision,
  milestoneRequestFromBid: datastoreCollections.milestoneRequestFromBid,
  mobileAppDevelopmentSkill: datastoreCollections.mobileAppDevelopmentSkill,
  mobileDevelopmentProfile: datastoreCollections.mobileDevelopmentProfile,
  modalCustomCta: datastoreCollections.modalCustomCta,
  moderatorPermissions: datastoreCollections.moderatorPermissions,
  multiProfilesBenefit: datastoreCollections.multiProfilesBenefit,
  muteNewsfeedGroup: datastoreCollections.muteNewsfeedGroup,
  mutedPermissions: datastoreCollections.mutedPermissions,
  nasaAdminEnterprise: datastoreCollections.nasaAdminEnterprise,
  nasaEnterprise: datastoreCollections.nasaEnterprise,
  nasaUser: datastoreCollections.nasaUser,
  ndaUpgrade: datastoreCollections.ndaUpgrade,
  newsfeedApiEntrySkipped: datastoreCollections.newsfeedApiEntrySkipped,
  nonRookieSearchUser: datastoreCollections.nonRookieSearchUser,
  nonRookieUser: datastoreCollections.nonRookieUser,
  npsiScoreMetric: datastoreCollections.npsiScoreMetric,
  nswSouthRegion: datastoreCollections.nswSouthRegion,
  nswSydneyRegion: datastoreCollections.nswSydneyRegion,
  nswWestRegion: datastoreCollections.nswWestRegion,
  offeringPortfolio: datastoreCollections.offeringPortfolio,
  offsitingMessageReminderFreelancerRichMessage:
    datastoreCollections.offsitingMessageReminderFreelancerRichMessage,
  onboardingEmailChangeBackend:
    datastoreCollections.onboardingEmailChangeBackend,
  oneOfValidationValues: datastoreCollections.oneOfValidationValues,
  ongoingProject: datastoreCollections.ongoingProject,
  openGraphDetailsBackend: datastoreCollections.openGraphDetailsBackend,
  openGraphDetailsReducer: datastoreCollections.openGraphDetailsReducer,
  openLinkInvitation: datastoreCollections.openLinkInvitation,
  orderBidsByBidScore: datastoreCollections.orderBidsByBidScore,
  otherSkill: datastoreCollections.otherSkill,
  palletJackType: datastoreCollections.palletJackType,
  palletsSkill: datastoreCollections.palletsSkill,
  partiallyPaidBidMilestone: datastoreCollections.partiallyPaidBidMilestone,
  partlyPaidCompleteBid: datastoreCollections.partlyPaidCompleteBid,
  paymentUnverifiedUser: datastoreCollections.paymentUnverifiedUser,
  payoutAccountsBackend: datastoreCollections.payoutAccountsBackend,
  pendingBid: datastoreCollections.pendingBid,
  pendingClearanceMilestone: datastoreCollections.pendingClearanceMilestone,
  pendingContest: datastoreCollections.pendingContest,
  pendingEntry: datastoreCollections.pendingEntry,
  pendingKycMilestone: datastoreCollections.pendingKycMilestone,
  pendingKycRequestWithAddressDocument:
    datastoreCollections.pendingKycRequestWithAddressDocument,
  pendingMilestone: datastoreCollections.pendingMilestone,
  pendingMilestoneRequest: datastoreCollections.pendingMilestoneRequest,
  pendingProject: datastoreCollections.pendingProject,
  perlSkill: datastoreCollections.perlSkill,
  phoneNumberSkype: datastoreCollections.phoneNumberSkype,
  phoneNumberWorkCell: datastoreCollections.phoneNumberWorkCell,
  phoneUnverifiedUser: datastoreCollections.phoneUnverifiedUser,
  photographySkill: datastoreCollections.photographySkill,
  photoshopSkill: datastoreCollections.photoshopSkill,
  phpCategoryPage: datastoreCollections.phpCategoryPage,
  phpHirePageDetailsResult: datastoreCollections.phpHirePageDetailsResult,
  phpLevel1Exam: datastoreCollections.phpLevel1Exam,
  phpSkill: datastoreCollections.phpSkill,
  phpSkillSubNavigationItem: datastoreCollections.phpSkillSubNavigationItem,
  pjpSubheader: datastoreCollections.pjpSubheader,
  pmiUser: datastoreCollections.pmiUser,
  portfolioCategoriesBenefit: datastoreCollections.portfolioCategoriesBenefit,
  ppmdEmailBody: datastoreCollections.ppmdEmailBody,
  ppmdEmailSubject: datastoreCollections.ppmdEmailSubject,
  practice: datastoreCollections.practice,
  preapprovedRepostPjpSubheader:
    datastoreCollections.preapprovedRepostPjpSubheader,
  preferredBillingAgreementsBackend:
    datastoreCollections.preferredBillingAgreementsBackend,
  premiumProject: datastoreCollections.premiumProject,
  premiumVerifiedProject: datastoreCollections.premiumVerifiedProject,
  projectContext: datastoreCollections.projectContext,
  projectFeedProjectEntriesFromSkills:
    datastoreCollections.projectFeedProjectEntriesFromSkills,
  projectFromMelbourne: datastoreCollections.projectFromMelbourne,
  projectFromSydney: datastoreCollections.projectFromSydney,
  projectFromVaticanCity: datastoreCollections.projectFromVaticanCity,
  projectHasOwnerId: datastoreCollections.projectHasOwnerId,
  projectSkillsMetric: datastoreCollections.projectSkillsMetric,
  projectToMelbourne: datastoreCollections.projectToMelbourne,
  projectViewPageFileContext: datastoreCollections.projectViewPageFileContext,
  projectViewProjectFromProject:
    datastoreCollections.projectViewProjectFromProject,
  projectsAwardedMetric: datastoreCollections.projectsAwardedMetric,
  projectsPostedMetric: datastoreCollections.projectsPostedMetric,
  projectsUnawardedMetric: datastoreCollections.projectsUnawardedMetric,
  publishedQuotation: datastoreCollections.publishedQuotation,
  pythonSkill: datastoreCollections.pythonSkill,
  qldBrisbaneRegion: datastoreCollections.qldBrisbaneRegion,
  reactionForPost: datastoreCollections.reactionForPost,
  readPermission: datastoreCollections.readPermission,
  recentlyViewedCollection: datastoreCollections.recentlyViewedCollection,
  recruiterUser: datastoreCollections.recruiterUser,
  recurringBillingInformationBackend:
    datastoreCollections.recurringBillingInformationBackend,
  registeredUserInvitation: datastoreCollections.registeredUserInvitation,
  rejectedBid: datastoreCollections.rejectedBid,
  rejectedEntry: datastoreCollections.rejectedEntry,
  rejectedKycRequest: datastoreCollections.rejectedKycRequest,
  rejectedProject: datastoreCollections.rejectedProject,
  rejectedProjectNote: datastoreCollections.rejectedProjectNote,
  rejectedQuotation: datastoreCollections.rejectedQuotation,
  rejectedRepostPjpSubheader: datastoreCollections.rejectedRepostPjpSubheader,
  relatedArticle: datastoreCollections.relatedArticle,
  reminderUserToComeBackEmailBody:
    datastoreCollections.reminderUserToComeBackEmailBody,
  reminderUserToComeBackEmailSubject:
    datastoreCollections.reminderUserToComeBackEmailSubject,
  requestedReleaseMilestone: datastoreCollections.requestedReleaseMilestone,
  restrictedLinkInvitation: datastoreCollections.restrictedLinkInvitation,
  revokedBid: datastoreCollections.revokedBid,
  richTextDescription: datastoreCollections.richTextDescription,
  rookieSearchUser: datastoreCollections.rookieSearchUser,
  rookieUser: datastoreCollections.rookieUser,
  rookieUserReputation: datastoreCollections.rookieUserReputation,
  rookieUsers: datastoreCollections.rookieUsers,
  saAdelaideRegion: datastoreCollections.saAdelaideRegion,
  saNorthRegion: datastoreCollections.saNorthRegion,
  sealedEntry: datastoreCollections.sealedEntry,
  sealedUpgrade: datastoreCollections.sealedUpgrade,
  searchSavedFiltersBackend: datastoreCollections.searchSavedFiltersBackend,
  sellerConfirmedContestHandover:
    datastoreCollections.sellerConfirmedContestHandover,
  sellerSignedContestHandover: datastoreCollections.sellerSignedContestHandover,
  serviceOfferingAttachmentsBackend:
    datastoreCollections.serviceOfferingAttachmentsBackend,
  serviceOfferingBuyerHistoriesBackend:
    datastoreCollections.serviceOfferingBuyerHistoriesBackend,
  serviceOfferingDiscountedPriceFixed:
    datastoreCollections.serviceOfferingDiscountedPriceFixed,
  serviceOfferingDiscountedPricePercentage:
    datastoreCollections.serviceOfferingDiscountedPricePercentage,
  serviceOfferingShopCategoriesBackend:
    datastoreCollections.serviceOfferingShopCategoriesBackend,
  serviceOfferingShopCategoryServicesBackend:
    datastoreCollections.serviceOfferingShopCategoryServicesBackend,
  serviceOfferingShopsBackend: datastoreCollections.serviceOfferingShopsBackend,
  serviceOfferingsBackend: datastoreCollections.serviceOfferingsBackend,
  serviceOfferingsWithOwnerDetailsBackend:
    datastoreCollections.serviceOfferingsWithOwnerDetailsBackend,
  serviceQuotation: datastoreCollections.serviceQuotation,
  sessionToBidSummariesTransformer:
    datastoreCollections.sessionToBidSummariesTransformer,
  setExpiryDate: datastoreCollections.setExpiryDate,
  setPreferredFreelancersOnlyBackend:
    datastoreCollections.setPreferredFreelancersOnlyBackend,
  setPreferredFreelancersOnlyReducer:
    datastoreCollections.setPreferredFreelancersOnlyReducer,
  signedBy: datastoreCollections.signedBy,
  skillAnswerDriveable: datastoreCollections.skillAnswerDriveable,
  skillAnswerNotDriveable: datastoreCollections.skillAnswerNotDriveable,
  skillAnswerNotRegistered: datastoreCollections.skillAnswerNotRegistered,
  skillAnswerRegistered: datastoreCollections.skillAnswerRegistered,
  skillQuestionDriveable: datastoreCollections.skillQuestionDriveable,
  skillQuestionEmpty: datastoreCollections.skillQuestionEmpty,
  skillQuestionHayOrGrassType: datastoreCollections.skillQuestionHayOrGrassType,
  skillQuestionPackageMethod: datastoreCollections.skillQuestionPackageMethod,
  skillQuestionRegistered: datastoreCollections.skillQuestionRegistered,
  skillQuestionRequiresProtection:
    datastoreCollections.skillQuestionRequiresProtection,
  skillsLimitBenefit: datastoreCollections.skillsLimitBenefit,
  snakeCase: datastoreCollections.snakeCase,
  soonExpiringContest: datastoreCollections.soonExpiringContest,
  specificDetails: datastoreCollections.specificDetails,
  spendOverTimeCumulativeSumMetric:
    datastoreCollections.spendOverTimeCumulativeSumMetric,
  spendOverTimeMetric: datastoreCollections.spendOverTimeMetric,
  staffUser: datastoreCollections.staffUser,
  subscriptionItemsBackend: datastoreCollections.subscriptionItemsBackend,
  subscriptionToSubscriptionHistoryTransformer:
    datastoreCollections.subscriptionToSubscriptionHistoryTransformer,
  supportStaff: datastoreCollections.supportStaff,
  supportUser: datastoreCollections.supportUser,
  swiftIdApplicantBackend: datastoreCollections.swiftIdApplicantBackend,
  swiftIdApplicationBackend: datastoreCollections.swiftIdApplicationBackend,
  swiftIdApplicationStatusBackend:
    datastoreCollections.swiftIdApplicationStatusBackend,
  swiftIdApplicationStatusReducer:
    datastoreCollections.swiftIdApplicationStatusReducer,
  swiftIdApplicationSubmitBackend:
    datastoreCollections.swiftIdApplicationSubmitBackend,
  swiftIdEnumBackend: datastoreCollections.swiftIdEnumBackend,
  swiftIdInvitationBackend: datastoreCollections.swiftIdInvitationBackend,
  swiftIdVerifySubmissionBackend:
    datastoreCollections.swiftIdVerifySubmissionBackend,
  talentNetworkAdminPool: datastoreCollections.talentNetworkAdminPool,
  talentNetworkPool: datastoreCollections.talentNetworkPool,
  talentSkillsMetric: datastoreCollections.talentSkillsMetric,
  tasmaniaRegion: datastoreCollections.tasmaniaRegion,
  techMahindraAdminEnterprise: datastoreCollections.techMahindraAdminEnterprise,
  telehandlerType: datastoreCollections.telehandlerType,
  templateQuotation: datastoreCollections.templateQuotation,
  textEntityUserComment: datastoreCollections.textEntityUserComment,
  textEntityUserPost: datastoreCollections.textEntityUserPost,
  timeTrackingSessionFromBid: datastoreCollections.timeTrackingSessionFromBid,
  tipperVehicleType: datastoreCollections.tipperVehicleType,
  toEmployer: datastoreCollections.toEmployer,
  toFreelancer: datastoreCollections.toFreelancer,
  toFreelancerNps: datastoreCollections.toFreelancerNps,
  tokenCurrency: datastoreCollections.tokenCurrency,
  topFreelancerFee: datastoreCollections.topFreelancerFee,
  translationSkill: datastoreCollections.translationSkill,
  unknownMilestone: datastoreCollections.unknownMilestone,
  unlistedProject: datastoreCollections.unlistedProject,
  unregisteredUserInvitation: datastoreCollections.unregisteredUserInvitation,
  unsubmittedKycRequestDetails:
    datastoreCollections.unsubmittedKycRequestDetails,
  unverifiedUser: datastoreCollections.unverifiedUser,
  updateProjectViewProjectBidStats:
    datastoreCollections.updateProjectViewProjectBidStats,
  usEnglishLevel1Exam: datastoreCollections.usEnglishLevel1Exam,
  usdCurrency: datastoreCollections.usdCurrency,
  userCustomEmailsBackend: datastoreCollections.userCustomEmailsBackend,
  userDisplayName: datastoreCollections.userDisplayName,
  userDocumentSubmissionFiles: datastoreCollections.userDocumentSubmissionFiles,
  userFromUsersSelf: datastoreCollections.userFromUsersSelf,
  userInfoFromUser: datastoreCollections.userInfoFromUser,
  userInfoWithSwitchUser: datastoreCollections.userInfoWithSwitchUser,
  userItem: datastoreCollections.userItem,
  userPermissionContext: datastoreCollections.userPermissionContext,
  userSkillsFromSkills: datastoreCollections.userSkillsFromSkills,
  userWithReviews: datastoreCollections.userWithReviews,
  usersActiveMetric: datastoreCollections.usersActiveMetric,
  usersTeamProfileBackend: datastoreCollections.usersTeamProfileBackend,
  usersTeamProfileReducer: datastoreCollections.usersTeamProfileReducer,
  usingAutomaticTimeTracking: datastoreCollections.usingAutomaticTimeTracking,
  uteType: datastoreCollections.uteType,
  uteVehicleType: datastoreCollections.uteVehicleType,
  validHourlyItem: datastoreCollections.validHourlyItem,
  validItem: datastoreCollections.validItem,
  validSubscriptionItem: datastoreCollections.validSubscriptionItem,
  vanVehicleType: datastoreCollections.vanVehicleType,
  vehicleCarrierVehicleType: datastoreCollections.vehicleCarrierVehicleType,
  vehicleTypeGroup: datastoreCollections.vehicleTypeGroup,
  verificationCorporateKycBackend:
    datastoreCollections.verificationCorporateKycBackend,
  verifiedUser: datastoreCollections.verifiedUser,
  vicEastRegion: datastoreCollections.vicEastRegion,
  vicMelbourneRegion: datastoreCollections.vicMelbourneRegion,
  videoContestFile: datastoreCollections.videoContestFile,
  warningDocumentSubmissionNote:
    datastoreCollections.warningDocumentSubmissionNote,
  wbsCodeToBusinessRelationship:
    datastoreCollections.wbsCodeToBusinessRelationship,
  wbsCodeToFSSValueRelationship:
    datastoreCollections.wbsCodeToFSSValueRelationship,
  wbsCodeToIndustryRelationship:
    datastoreCollections.wbsCodeToIndustryRelationship,
  wbsCodeToOfferingPortfolioRelationship:
    datastoreCollections.wbsCodeToOfferingPortfolioRelationship,
  webDesignProfile: datastoreCollections.webDesignProfile,
  webDevelopmentProfile: datastoreCollections.webDevelopmentProfile,
  websiteDesignProject: datastoreCollections.websiteDesignProject,
  websiteDesignSkill: datastoreCollections.websiteDesignSkill,
  wirePayoutAccountFieldData: datastoreCollections.wirePayoutAccountFieldData,
  wirePayoutAccountForm: datastoreCollections.wirePayoutAccountForm,
  wirePayoutMethod: datastoreCollections.wirePayoutMethod,
  withContactNumberRestrictionPenalty:
    datastoreCollections.withContactNumberRestrictionPenalty,
  withContactSignature: datastoreCollections.withContactSignature,
  withContestChallengeElement: datastoreCollections.withContestChallengeElement,
  withContestSourceType: datastoreCollections.withContestSourceType,
  withContext: datastoreCollections.withContext,
  withDeliveryItems: datastoreCollections.withDeliveryItems,
  withDepositFailureSupportType:
    datastoreCollections.withDepositFailureSupportType,
  withDiscoverSupportType: datastoreCollections.withDiscoverSupportType,
  withDuration: datastoreCollections.withDuration,
  withEntries: datastoreCollections.withEntries,
  withEntriesForContestViewEntryIds:
    datastoreCollections.withEntriesForContestViewEntryIds,
  withEqaSupportType: datastoreCollections.withEqaSupportType,
  withExperFreelancerScreeningSupportType:
    datastoreCollections.withExperFreelancerScreeningSupportType,
  withFirstModalWarning: datastoreCollections.withFirstModalWarning,
  withFreelancerVerifiedSupportType:
    datastoreCollections.withFreelancerVerifiedSupportType,
  withFreightlancerConciergeContext:
    datastoreCollections.withFreightlancerConciergeContext,
  withFreightlancerSupportType:
    datastoreCollections.withFreightlancerSupportType,
  withFullRestrictionPenalty: datastoreCollections.withFullRestrictionPenalty,
  withGeneralSupportType: datastoreCollections.withGeneralSupportType,
  withHpAwaitingDeliverySupportType:
    datastoreCollections.withHpAwaitingDeliverySupportType,
  withHpIncomingProjectSupportType:
    datastoreCollections.withHpIncomingProjectSupportType,
  withHpProgressBlockedSupportType:
    datastoreCollections.withHpProgressBlockedSupportType,
  withHpReviewFailuresSupportType:
    datastoreCollections.withHpReviewFailuresSupportType,
  withHpReviewSupportType: datastoreCollections.withHpReviewSupportType,
  withInvoiceSourceType: datastoreCollections.withInvoiceSourceType,
  withLoadshiftMarketplaceSupportType:
    datastoreCollections.withLoadshiftMarketplaceSupportType,
  withLocalJobSupportType: datastoreCollections.withLocalJobSupportType,
  withLocation: datastoreCollections.withLocation,
  withMembershipCurationSupportType:
    datastoreCollections.withMembershipCurationSupportType,
  withMessage: datastoreCollections.withMessage,
  withMobileNumber: datastoreCollections.withMobileNumber,
  withNoneContext: datastoreCollections.withNoneContext,
  withNotes: datastoreCollections.withNotes,
  withOffsiteSourceType: datastoreCollections.withOffsiteSourceType,
  withOffsiteSupportType: datastoreCollections.withOffsiteSupportType,
  withPaymentSatisfactionSupportType:
    datastoreCollections.withPaymentSatisfactionSupportType,
  withPermissions: datastoreCollections.withPermissions,
  withPfpTicketsSupportType: datastoreCollections.withPfpTicketsSupportType,
  withPhpExam: datastoreCollections.withPhpExam,
  withPjpAssistantSupportType: datastoreCollections.withPjpAssistantSupportType,
  withProfilePictureCurationSupportType:
    datastoreCollections.withProfilePictureCurationSupportType,
  withProjectManagementSupportType:
    datastoreCollections.withProjectManagementSupportType,
  withProjectQualityAuditSupportType:
    datastoreCollections.withProjectQualityAuditSupportType,
  withProjectSourceType: datastoreCollections.withProjectSourceType,
  withRecruiterSupportType: datastoreCollections.withRecruiterSupportType,
  withReputation: datastoreCollections.withReputation,
  withScreenshot: datastoreCollections.withScreenshot,
  withSecondModalWarning: datastoreCollections.withSecondModalWarning,
  withSuccessManagerSupportType:
    datastoreCollections.withSuccessManagerSupportType,
  withSupportBanner: datastoreCollections.withSupportBanner,
  withTargetId: datastoreCollections.withTargetId,
  withTicketSourceType: datastoreCollections.withTicketSourceType,
  withTransactionSourceType: datastoreCollections.withTransactionSourceType,
  withUnlinkedChallengeElement:
    datastoreCollections.withUnlinkedChallengeElement,
  withUserContext: datastoreCollections.withUserContext,
  withUserSourceType: datastoreCollections.withUserSourceType,
  withdrawalVideoVerificationRequest:
    datastoreCollections.withdrawalVideoVerificationRequest,
  withdrawnEliminatedEntry: datastoreCollections.withdrawnEliminatedEntry,
  withdrawnEntry: datastoreCollections.withdrawnEntry,
  withoutSkills: datastoreCollections.withoutSkills,
  wonEmailBody: datastoreCollections.wonEmailBody,
  wonEmailSubject: datastoreCollections.wonEmailSubject,
  zeroFees: datastoreCollections.zeroFees,
  addMutationPropagator: documentCreators.addMutationPropagator,
  addPushTransformer: documentCreators.addPushTransformer,
  addSearchTransformer: documentCreators.addSearchTransformer,
  addUpdateTransformer: documentCreators.addUpdateTransformer,
  clearCollectionDelayed: documentCreators.clearCollectionDelayed,
  clearCollectionFailDelete: documentCreators.clearCollectionFailDelete,
  clearCollectionFailFetch: documentCreators.clearCollectionFailFetch,
  clearCollectionFailPush: documentCreators.clearCollectionFailPush,
  clearCollectionFailSet: documentCreators.clearCollectionFailSet,
  clearCollectionFailUpdate: documentCreators.clearCollectionFailUpdate,
  clearCollectionFailWhenEmpty: documentCreators.clearCollectionFailWhenEmpty,
  clearCollectionPending: documentCreators.clearCollectionPending,
  clearRequestFail: documentCreators.clearRequestFail,
  createAbnDetails: documentCreators.createAbnDetails,
  createAccountProgress: documentCreators.createAccountProgress,
  createAdminChallenge: documentCreators.createAdminChallenge,
  createAdminEnterprises: documentCreators.createAdminEnterprises,
  createAdminExternalCredentialAllocation:
    documentCreators.createAdminExternalCredentialAllocation,
  createAdminExternalCredentialAllocationLog:
    documentCreators.createAdminExternalCredentialAllocationLog,
  createAdminExternalCredentialProvider:
    documentCreators.createAdminExternalCredentialProvider,
  createAdminPools: documentCreators.createAdminPools,
  createAdminProjectDescriptionUpdate:
    documentCreators.createAdminProjectDescriptionUpdate,
  createAdminUserDocumentSubmissions:
    documentCreators.createAdminUserDocumentSubmissions,
  createAdminUserEnterprises: documentCreators.createAdminUserEnterprises,
  createAdminUserVerificationProcess:
    documentCreators.createAdminUserVerificationProcess,
  createAgent: documentCreators.createAgent,
  createAgentSession: documentCreators.createAgentSession,
  createAgentSessions: documentCreators.createAgentSessions,
  createAgents: documentCreators.createAgents,
  createAiPrompt: documentCreators.createAiPrompt,
  createAiPromptBuilder: documentCreators.createAiPromptBuilder,
  createAnalytics: documentCreators.createAnalytics,
  createAppInstallTrackingRecord:
    documentCreators.createAppInstallTrackingRecord,
  createArticle: documentCreators.createArticle,
  createBanners: documentCreators.createBanners,
  createBid: documentCreators.createBid,
  createBidBuyerProjectFee: documentCreators.createBidBuyerProjectFee,
  createBidPitch: documentCreators.createBidPitch,
  createBidRestriction: documentCreators.createBidRestriction,
  createBidScore: documentCreators.createBidScore,
  createBidSummary: documentCreators.createBidSummary,
  createBidUpgradeFee: documentCreators.createBidUpgradeFee,
  createBids: documentCreators.createBids,
  createBillingAgreement: documentCreators.createBillingAgreement,
  createBillingAgreements: documentCreators.createBillingAgreements,
  createCampaign: documentCreators.createCampaign,
  createCanViewEmployerProfile: documentCreators.createCanViewEmployerProfile,
  createCanvas: documentCreators.createCanvas,
  createCart: documentCreators.createCart,
  createCartApproval: documentCreators.createCartApproval,
  createCartItem: documentCreators.createCartItem,
  createCategory: documentCreators.createCategory,
  createCategoryPageContent: documentCreators.createCategoryPageContent,
  createCategoryPageViewUser: documentCreators.createCategoryPageViewUser,
  createCertification: documentCreators.createCertification,
  createChallenge: documentCreators.createChallenge,
  createChallenges: documentCreators.createChallenges,
  createCheckInSchedule: documentCreators.createCheckInSchedule,
  createComment: documentCreators.createComment,
  createCommentFeed: documentCreators.createCommentFeed,
  createComments: documentCreators.createComments,
  createContentCustomization: documentCreators.createContentCustomization,
  createContentCustomizations: documentCreators.createContentCustomizations,
  createContest: documentCreators.createContest,
  createContestBudgetRanges: documentCreators.createContestBudgetRanges,
  createContestCollaborator: documentCreators.createContestCollaborator,
  createContestEngagement: documentCreators.createContestEngagement,
  createContestEntries: documentCreators.createContestEntries,
  createContestEntry: documentCreators.createContestEntry,
  createContestEntryOffer: documentCreators.createContestEntryOffer,
  createContestFees: documentCreators.createContestFees,
  createContestFile: documentCreators.createContestFile,
  createContestFiles: documentCreators.createContestFiles,
  createContestHandover: documentCreators.createContestHandover,
  createContestHandoverFile: documentCreators.createContestHandoverFile,
  createContestInterestedUser: documentCreators.createContestInterestedUser,
  createContestPrizeDetail: documentCreators.createContestPrizeDetail,
  createContestQuickviewEntries: documentCreators.createContestQuickviewEntries,
  createContestUserHasGivenFeedback:
    documentCreators.createContestUserHasGivenFeedback,
  createContestViewContest: documentCreators.createContestViewContest,
  createContestViewEntries: documentCreators.createContestViewEntries,
  createContestViewEntryIds: documentCreators.createContestViewEntryIds,
  createContract: documentCreators.createContract,
  createContractDownloadUrl: documentCreators.createContractDownloadUrl,
  createCountries: documentCreators.createCountries,
  createCountryStates: documentCreators.createCountryStates,
  createCurrencies: documentCreators.createCurrencies,
  createCurrencyIncludingExternal:
    documentCreators.createCurrencyIncludingExternal,
  createCustomBanner: documentCreators.createCustomBanner,
  createCustomFieldInfoConfigurations:
    documentCreators.createCustomFieldInfoConfigurations,
  createCustomFieldRelationship: documentCreators.createCustomFieldRelationship,
  createCustomFieldValidation: documentCreators.createCustomFieldValidation,
  createDashboardPoll: documentCreators.createDashboardPoll,
  createDashboardWidgets: documentCreators.createDashboardWidgets,
  createDepositPageVars: documentCreators.createDepositPageVars,
  createDetectedCurrencies: documentCreators.createDetectedCurrencies,
  createDiscoverCollection: documentCreators.createDiscoverCollection,
  createDiscoverCollectionItem: documentCreators.createDiscoverCollectionItem,
  createDiscoverCollectionItemSaveCount:
    documentCreators.createDiscoverCollectionItemSaveCount,
  createDiscoverCollectionItemSaveCounts:
    documentCreators.createDiscoverCollectionItemSaveCounts,
  createDomain: documentCreators.createDomain,
  createDriveFile: documentCreators.createDriveFile,
  createDriveFilePermission: documentCreators.createDriveFilePermission,
  createEducation: documentCreators.createEducation,
  createEmployerReputationsRehireRates:
    documentCreators.createEmployerReputationsRehireRates,
  createEncodedUrl: documentCreators.createEncodedUrl,
  createEnterprise: documentCreators.createEnterprise,
  createEnterpriseBillingAgreementBalance:
    documentCreators.createEnterpriseBillingAgreementBalance,
  createEnterprises: documentCreators.createEnterprises,
  createEntryRestriction: documentCreators.createEntryRestriction,
  createExams: documentCreators.createExams,
  createExchangeRates: documentCreators.createExchangeRates,
  createExperience: documentCreators.createExperience,
  createExperiences: documentCreators.createExperiences,
  createExternalContactStatus: documentCreators.createExternalContactStatus,
  createExternalReference: documentCreators.createExternalReference,
  createExternalReferenceReminder:
    documentCreators.createExternalReferenceReminder,
  createFeedItem: documentCreators.createFeedItem,
  createFeedMeta: documentCreators.createFeedMeta,
  createFeedPost: documentCreators.createFeedPost,
  createFindPageDetails: documentCreators.createFindPageDetails,
  createFlareActionMap: documentCreators.createFlareActionMap,
  createFlareCheckpoint: documentCreators.createFlareCheckpoint,
  createFlareRule: documentCreators.createFlareRule,
  createFlareRuleset: documentCreators.createFlareRuleset,
  createFreelancerReputation: documentCreators.createFreelancerReputation,
  createFreelancerReputations: documentCreators.createFreelancerReputations,
  createFreelancerReputationsRehireRate:
    documentCreators.createFreelancerReputationsRehireRate,
  createFreelancerReputationsRehireRates:
    documentCreators.createFreelancerReputationsRehireRates,
  createGrant: documentCreators.createGrant,
  createGrants: documentCreators.createGrants,
  createGroup: documentCreators.createGroup,
  createGroupActions: documentCreators.createGroupActions,
  createGroupAttachments: documentCreators.createGroupAttachments,
  createGroupFeed: documentCreators.createGroupFeed,
  createGroupMembers: documentCreators.createGroupMembers,
  createGroupPermissions: documentCreators.createGroupPermissions,
  createGroups: documentCreators.createGroups,
  createGroupsSelf: documentCreators.createGroupsSelf,
  createGuideline: documentCreators.createGuideline,
  createHirePageDetails: documentCreators.createHirePageDetails,
  createHourlyContract: documentCreators.createHourlyContract,
  createHourlyProjectMilestoneFee:
    documentCreators.createHourlyProjectMilestoneFee,
  createInvitation: documentCreators.createInvitation,
  createInvoice: documentCreators.createInvoice,
  createIpContract: documentCreators.createIpContract,
  createIrisOffsitingMessages: documentCreators.createIrisOffsitingMessages,
  createIsFreeBids: documentCreators.createIsFreeBids,
  createIsLookingForWork: documentCreators.createIsLookingForWork,
  createLanguage: documentCreators.createLanguage,
  createLanguages: documentCreators.createLanguages,
  createLoadPriceEstimate: documentCreators.createLoadPriceEstimate,
  createLoadTypes: documentCreators.createLoadTypes,
  createLoadshiftSiteStats: documentCreators.createLoadshiftSiteStats,
  createLoginDevicesObject: documentCreators.createLoginDevicesObject,
  createManageViewContest: documentCreators.createManageViewContest,
  createManageViewContestHandover:
    documentCreators.createManageViewContestHandover,
  createManageViewContestHandovers:
    documentCreators.createManageViewContestHandovers,
  createManageViewOngoingBids: documentCreators.createManageViewOngoingBids,
  createManageViewOngoingProjects:
    documentCreators.createManageViewOngoingProjects,
  createManageViewOpenBids: documentCreators.createManageViewOpenBids,
  createManageViewOpenProject: documentCreators.createManageViewOpenProject,
  createManageViewOpenProjects: documentCreators.createManageViewOpenProjects,
  createManageViewPastBids: documentCreators.createManageViewPastBids,
  createManageViewPastProject: documentCreators.createManageViewPastProject,
  createManageViewPastProjects: documentCreators.createManageViewPastProjects,
  createMarketingMobileNumber: documentCreators.createMarketingMobileNumber,
  createMembershipBenefit: documentCreators.createMembershipBenefit,
  createMembershipDowngrade: documentCreators.createMembershipDowngrade,
  createMembershipPackages: documentCreators.createMembershipPackages,
  createMembershipRenewals: documentCreators.createMembershipRenewals,
  createMembershipSubscriptionHistory:
    documentCreators.createMembershipSubscriptionHistory,
  createMembershipTrials: documentCreators.createMembershipTrials,
  createMessage: documentCreators.createMessage,
  createMessages: documentCreators.createMessages,
  createMilestone: documentCreators.createMilestone,
  createMilestoneDraft: documentCreators.createMilestoneDraft,
  createMilestoneRequest: documentCreators.createMilestoneRequest,
  createMilestoneRequests: documentCreators.createMilestoneRequests,
  createMilestones: documentCreators.createMilestones,
  createNativeExchangeRates: documentCreators.createNativeExchangeRates,
  createNearbyProject: documentCreators.createNearbyProject,
  createNewsfeedActivateFreelancer:
    documentCreators.createNewsfeedActivateFreelancer,
  createNewsfeedAwardProjectCorporateTeam:
    documentCreators.createNewsfeedAwardProjectCorporateTeam,
  createNewsfeedBookmarkedProjectAwarded:
    documentCreators.createNewsfeedBookmarkedProjectAwarded,
  createNewsfeedClientViewedBid: documentCreators.createNewsfeedClientViewedBid,
  createNewsfeedContestPcb: documentCreators.createNewsfeedContestPcb,
  createNewsfeedCorporateTeamBidPlaced:
    documentCreators.createNewsfeedCorporateTeamBidPlaced,
  createNewsfeedCreateMilestone: documentCreators.createNewsfeedCreateMilestone,
  createNewsfeedCustomAdminNotification:
    documentCreators.createNewsfeedCustomAdminNotification,
  createNewsfeedDenied: documentCreators.createNewsfeedDenied,
  createNewsfeedDraftContest: documentCreators.createNewsfeedDraftContest,
  createNewsfeedEscalateDispute: documentCreators.createNewsfeedEscalateDispute,
  createNewsfeedHireMe: documentCreators.createNewsfeedHireMe,
  createNewsfeedHireMeExpired: documentCreators.createNewsfeedHireMeExpired,
  createNewsfeedIndianMandateMembershipRecurringReminder:
    documentCreators.createNewsfeedIndianMandateMembershipRecurringReminder,
  createNewsfeedIndianMandateMembershipVerificationReminder:
    documentCreators.createNewsfeedIndianMandateMembershipVerificationReminder,
  createNewsfeedInternalLinkedProjectAwardReminder:
    documentCreators.createNewsfeedInternalLinkedProjectAwardReminder,
  createNewsfeedInviteUserBid: documentCreators.createNewsfeedInviteUserBid,
  createNewsfeedProjectAccepted: documentCreators.createNewsfeedProjectAccepted,
  createNewsfeedProjectAwarded: documentCreators.createNewsfeedProjectAwarded,
  createNewsfeedProjectBidOn: documentCreators.createNewsfeedProjectBidOn,
  createNewsfeedProjectEditRequest:
    documentCreators.createNewsfeedProjectEditRequest,
  createNewsfeedProjectReviewActivate:
    documentCreators.createNewsfeedProjectReviewActivate,
  createNewsfeedProjectReviewPostedNew:
    documentCreators.createNewsfeedProjectReviewPostedNew,
  createNewsfeedRejected: documentCreators.createNewsfeedRejected,
  createNewsfeedReleaseMilestone:
    documentCreators.createNewsfeedReleaseMilestone,
  createNewsfeedRequestMilestone:
    documentCreators.createNewsfeedRequestMilestone,
  createNewsfeedRequestToRelease:
    documentCreators.createNewsfeedRequestToRelease,
  createNewsfeedSendQuote: documentCreators.createNewsfeedSendQuote,
  createNewsfeedShowcaseSourceApproval:
    documentCreators.createNewsfeedShowcaseSourceApproval,
  createNewsfeedSuggestionForFreelancerAfterReceiveReview:
    documentCreators.createNewsfeedSuggestionForFreelancerAfterReceiveReview,
  createNewsfeedTaskGroupNewUser:
    documentCreators.createNewsfeedTaskGroupNewUser,
  createNewsfeedUpdateMilestone: documentCreators.createNewsfeedUpdateMilestone,
  createNewsfeedWelcome: documentCreators.createNewsfeedWelcome,
  createNotificationEarningTaxCollected:
    documentCreators.createNotificationEarningTaxCollected,
  createNotificationGroupNotification:
    documentCreators.createNotificationGroupNotification,
  createNotificationGroupReactNotification:
    documentCreators.createNotificationGroupReactNotification,
  createNotificationGroupReplyNotification:
    documentCreators.createNotificationGroupReplyNotification,
  createNotificationProjectCommentCreate:
    documentCreators.createNotificationProjectCommentCreate,
  createNotificationProjectCompleted:
    documentCreators.createNotificationProjectCompleted,
  createNotificationRequestCancelMilestone:
    documentCreators.createNotificationRequestCancelMilestone,
  createNotificationRequestMilestone:
    documentCreators.createNotificationRequestMilestone,
  createNotificationRequestToRelease:
    documentCreators.createNotificationRequestToRelease,
  createNotificationSettings: documentCreators.createNotificationSettings,
  createNotificationTaskCommentCreate:
    documentCreators.createNotificationTaskCommentCreate,
  createNotificationTaskCreateEdit:
    documentCreators.createNotificationTaskCreateEdit,
  createNotificationTaskGroupNewUser:
    documentCreators.createNotificationTaskGroupNewUser,
  createNotificationUpgradeToNonFreeMembership:
    documentCreators.createNotificationUpgradeToNonFreeMembership,
  createNotificationUploadFile: documentCreators.createNotificationUploadFile,
  createNotificationsPreferences:
    documentCreators.createNotificationsPreferences,
  createOnBehalfProject: documentCreators.createOnBehalfProject,
  createOnboardingEmailChangeEligibility:
    documentCreators.createOnboardingEmailChangeEligibility,
  createOnlineOffline: documentCreators.createOnlineOffline,
  createOperatingAreaRegions: documentCreators.createOperatingAreaRegions,
  createParentContestComment: documentCreators.createParentContestComment,
  createPartialSearchArticles: documentCreators.createPartialSearchArticles,
  createPaymentShareInterest: documentCreators.createPaymentShareInterest,
  createPaymentShareMembers: documentCreators.createPaymentShareMembers,
  createPaymentShareMembersSpentAmount:
    documentCreators.createPaymentShareMembersSpentAmount,
  createPaymentShareTeams: documentCreators.createPaymentShareTeams,
  createPaymentShareWhitelistItem:
    documentCreators.createPaymentShareWhitelistItem,
  createPayoutLimitExemptions: documentCreators.createPayoutLimitExemptions,
  createPjpDraft: documentCreators.createPjpDraft,
  createPools: documentCreators.createPools,
  createPortfolio: documentCreators.createPortfolio,
  createPortfolios: documentCreators.createPortfolios,
  createPostFiles: documentCreators.createPostFiles,
  createPredefinedDiscoverCollection:
    documentCreators.createPredefinedDiscoverCollection,
  createPredictedSkill: documentCreators.createPredictedSkill,
  createPreferredBillingAgreement:
    documentCreators.createPreferredBillingAgreement,
  createPreferredSupportAgentAssignments:
    documentCreators.createPreferredSupportAgentAssignments,
  createProfile: documentCreators.createProfile,
  createProfileViewUser: documentCreators.createProfileViewUser,
  createProfileViewUsers: documentCreators.createProfileViewUsers,
  createProfiles: documentCreators.createProfiles,
  createProject: documentCreators.createProject,
  createProjectBidInfo: documentCreators.createProjectBidInfo,
  createProjectBidStats: documentCreators.createProjectBidStats,
  createProjectBookmark: documentCreators.createProjectBookmark,
  createProjectBookmarks: documentCreators.createProjectBookmarks,
  createProjectBudgetOptions: documentCreators.createProjectBudgetOptions,
  createProjectCollaboration: documentCreators.createProjectCollaboration,
  createProjectCollaborations: documentCreators.createProjectCollaborations,
  createProjectContestClassification:
    documentCreators.createProjectContestClassification,
  createProjectDeliveryContactSensitiveDetails:
    documentCreators.createProjectDeliveryContactSensitiveDetails,
  createProjectFeed: documentCreators.createProjectFeed,
  createProjectGroup: documentCreators.createProjectGroup,
  createProjectGroups: documentCreators.createProjectGroups,
  createProjectMatchInsight: documentCreators.createProjectMatchInsight,
  createProjectQualityDetails: documentCreators.createProjectQualityDetails,
  createProjectSeo: documentCreators.createProjectSeo,
  createProjectSkillsPrediction: documentCreators.createProjectSkillsPrediction,
  createProjectSpamControls: documentCreators.createProjectSpamControls,
  createProjectTitleEditRequest: documentCreators.createProjectTitleEditRequest,
  createProjectUpgradeFees: documentCreators.createProjectUpgradeFees,
  createProjectViewBids: documentCreators.createProjectViewBids,
  createProjectViewProject: documentCreators.createProjectViewProject,
  createProjectViewUser: documentCreators.createProjectViewUser,
  createProjectViewUsers: documentCreators.createProjectViewUsers,
  createPublication: documentCreators.createPublication,
  createQuotationItemRevision: documentCreators.createQuotationItemRevision,
  createQuotationItemRevisions: documentCreators.createQuotationItemRevisions,
  createQuotationLogo: documentCreators.createQuotationLogo,
  createQuotationRevision: documentCreators.createQuotationRevision,
  createRawDocument: documentCreators.createRawDocument,
  createReactionTypeCount: documentCreators.createReactionTypeCount,
  createReactionsTypeCount: documentCreators.createReactionsTypeCount,
  createRecentSavedSearchAlert: documentCreators.createRecentSavedSearchAlert,
  createRecommendedMembership: documentCreators.createRecommendedMembership,
  createRecommendedUserNames: documentCreators.createRecommendedUserNames,
  createRecurringBillingInformation:
    documentCreators.createRecurringBillingInformation,
  createRecurringBillingInformations:
    documentCreators.createRecurringBillingInformations,
  createReferralEligibility: documentCreators.createReferralEligibility,
  createReferralInvitation: documentCreators.createReferralInvitation,
  createReferralInvitationCheck: documentCreators.createReferralInvitationCheck,
  createReferralInvitations: documentCreators.createReferralInvitations,
  createReferralRecords: documentCreators.createReferralRecords,
  createReferralTokenObject: documentCreators.createReferralTokenObject,
  createReplyContestComment: documentCreators.createReplyContestComment,
  createReview: documentCreators.createReview,
  createReviewSkill: documentCreators.createReviewSkill,
  createReviews: documentCreators.createReviews,
  createSalesTax: documentCreators.createSalesTax,
  createScheduledSubscriptionPayment:
    documentCreators.createScheduledSubscriptionPayment,
  createScheduledSubscriptionPayments:
    documentCreators.createScheduledSubscriptionPayments,
  createSearchActiveContest: documentCreators.createSearchActiveContest,
  createSearchActiveContests: documentCreators.createSearchActiveContests,
  createSearchActiveLoad: documentCreators.createSearchActiveLoad,
  createSearchActiveLoads: documentCreators.createSearchActiveLoads,
  createSearchActiveProject: documentCreators.createSearchActiveProject,
  createSearchActiveProjects: documentCreators.createSearchActiveProjects,
  createSearchArticles: documentCreators.createSearchArticles,
  createSearchPreferredFreelancers:
    documentCreators.createSearchPreferredFreelancers,
  createSearchProjectsSelf: documentCreators.createSearchProjectsSelf,
  createSearchSavedFilters: documentCreators.createSearchSavedFilters,
  createSearchUser: documentCreators.createSearchUser,
  createSearchUsers: documentCreators.createSearchUsers,
  createSecurityPhoneRequestObject:
    documentCreators.createSecurityPhoneRequestObject,
  createServiceOffering: documentCreators.createServiceOffering,
  createServiceOfferingBuyerHistories:
    documentCreators.createServiceOfferingBuyerHistories,
  createServiceOfferingCategories:
    documentCreators.createServiceOfferingCategories,
  createServiceOfferingShop: documentCreators.createServiceOfferingShop,
  createServiceOfferingShopCategoryService:
    documentCreators.createServiceOfferingShopCategoryService,
  createServiceOfferingWithOwnerDetails:
    documentCreators.createServiceOfferingWithOwnerDetails,
  createSessionResolveReason: documentCreators.createSessionResolveReason,
  createShowcase: documentCreators.createShowcase,
  createShowcaseClientNotification:
    documentCreators.createShowcaseClientNotification,
  createShowcaseSources: documentCreators.createShowcaseSources,
  createShowcases: documentCreators.createShowcases,
  createSimilarFreelancers: documentCreators.createSimilarFreelancers,
  createSimilarShowcases: documentCreators.createSimilarShowcases,
  createSiteStat: documentCreators.createSiteStat,
  createSkills: documentCreators.createSkills,
  createSkillsSubNavigation: documentCreators.createSkillsSubNavigation,
  createSlaTask: documentCreators.createSlaTask,
  createSubscriptionItem: documentCreators.createSubscriptionItem,
  createSubscriptionItems: documentCreators.createSubscriptionItems,
  createSuggestedSkills: documentCreators.createSuggestedSkills,
  createSuperuserBids: documentCreators.createSuperuserBids,
  createSuperuserGroup: documentCreators.createSuperuserGroup,
  createSuperuserGroupMembers: documentCreators.createSuperuserGroupMembers,
  createSuperuserGroupPermissions:
    documentCreators.createSuperuserGroupPermissions,
  createSuperuserGroups: documentCreators.createSuperuserGroups,
  createSuperuserMilestone: documentCreators.createSuperuserMilestone,
  createSuperuserProjectNotes: documentCreators.createSuperuserProjectNotes,
  createSuperuserProjectViewAllProject:
    documentCreators.createSuperuserProjectViewAllProject,
  createSuperuserProjectViewProject:
    documentCreators.createSuperuserProjectViewProject,
  createSuperuserProjectViewUser:
    documentCreators.createSuperuserProjectViewUser,
  createSupportAnswer: documentCreators.createSupportAnswer,
  createSupportArticles: documentCreators.createSupportArticles,
  createSupportCategories: documentCreators.createSupportCategories,
  createSupportCategoryArticles: documentCreators.createSupportCategoryArticles,
  createSupportFeedbackIsAllowed:
    documentCreators.createSupportFeedbackIsAllowed,
  createSupportIssueCategories: documentCreators.createSupportIssueCategories,
  createSupportIssueCategoryArticles:
    documentCreators.createSupportIssueCategoryArticles,
  createSupportSuggestedArticles:
    documentCreators.createSupportSuggestedArticles,
  createSupportTag: documentCreators.createSupportTag,
  createSupportViewDetails: documentCreators.createSupportViewDetails,
  createSwiftIdApplicant: documentCreators.createSwiftIdApplicant,
  createSwiftIdApplication: documentCreators.createSwiftIdApplication,
  createSwiftIdApplicationStatus:
    documentCreators.createSwiftIdApplicationStatus,
  createSwiftIdCompanyApplication:
    documentCreators.createSwiftIdCompanyApplication,
  createSwiftIdIndustries: documentCreators.createSwiftIdIndustries,
  createSwiftIdInvitation: documentCreators.createSwiftIdInvitation,
  createSwiftIdNatureOfBusiness: documentCreators.createSwiftIdNatureOfBusiness,
  createSwiftIdOccupations: documentCreators.createSwiftIdOccupations,
  createSwiftIdSourcesOfFunds: documentCreators.createSwiftIdSourcesOfFunds,
  createSwiftIdSourcesOfWealth: documentCreators.createSwiftIdSourcesOfWealth,
  createTask: documentCreators.createTask,
  createTaskGroup: documentCreators.createTaskGroup,
  createTaskGroupMembers: documentCreators.createTaskGroupMembers,
  createTaskGroupSection: documentCreators.createTaskGroupSection,
  createTaskGroupSections: documentCreators.createTaskGroupSections,
  createTax: documentCreators.createTax,
  createTaxOptOutOptionObjects: documentCreators.createTaxOptOutOptionObjects,
  createTaxStatements: documentCreators.createTaxStatements,
  createTeam: documentCreators.createTeam,
  createTeamMember: documentCreators.createTeamMember,
  createTeamMembers: documentCreators.createTeamMembers,
  createThread: documentCreators.createThread,
  createThreadProject: documentCreators.createThreadProject,
  createTimeTrackingDailyAggregate:
    documentCreators.createTimeTrackingDailyAggregate,
  createTimeTrackingPunch: documentCreators.createTimeTrackingPunch,
  createTimeTrackingPunches: documentCreators.createTimeTrackingPunches,
  createTimeTrackingSession: documentCreators.createTimeTrackingSession,
  createTimeline: documentCreators.createTimeline,
  createTimezones: documentCreators.createTimezones,
  createTopSkills: documentCreators.createTopSkills,
  createTrackingConsentMode: documentCreators.createTrackingConsentMode,
  createUniversities: documentCreators.createUniversities,
  createUsStates: documentCreators.createUsStates,
  createUser: documentCreators.createUser,
  createUserAvailability: documentCreators.createUserAvailability,
  createUserBalances: documentCreators.createUserBalances,
  createUserBidLimit: documentCreators.createUserBidLimit,
  createUserBidOnRussianProject: documentCreators.createUserBidOnRussianProject,
  createUserCalifornianStatuses: documentCreators.createUserCalifornianStatuses,
  createUserCartRequiresEmailVerification:
    documentCreators.createUserCartRequiresEmailVerification,
  createUserCollaboration: documentCreators.createUserCollaboration,
  createUserConsent: documentCreators.createUserConsent,
  createUserContestCollaborationWhitelist:
    documentCreators.createUserContestCollaborationWhitelist,
  createUserDepositMethods: documentCreators.createUserDepositMethods,
  createUserDocumentSubmission: documentCreators.createUserDocumentSubmission,
  createUserDocumentSubmissions: documentCreators.createUserDocumentSubmissions,
  createUserEmailRequest: documentCreators.createUserEmailRequest,
  createUserFollow: documentCreators.createUserFollow,
  createUserFollows: documentCreators.createUserFollows,
  createUserGiveGetDetail: documentCreators.createUserGiveGetDetail,
  createUserHasDuplicateIp: documentCreators.createUserHasDuplicateIp,
  createUserHasGivenFeedback: documentCreators.createUserHasGivenFeedback,
  createUserInfo: documentCreators.createUserInfo,
  createUserInsignias: documentCreators.createUserInsignias,
  createUserInteraction: documentCreators.createUserInteraction,
  createUserLocation: documentCreators.createUserLocation,
  createUserNotificationPreferences:
    documentCreators.createUserNotificationPreferences,
  createUserNps: documentCreators.createUserNps,
  createUserPaymentControl: documentCreators.createUserPaymentControl,
  createUserPayoutAccountForms: documentCreators.createUserPayoutAccountForms,
  createUserPayoutAccounts: documentCreators.createUserPayoutAccounts,
  createUserPayoutContext: documentCreators.createUserPayoutContext,
  createUserPayoutMethods: documentCreators.createUserPayoutMethods,
  createUserPhoneVerificationBackoff:
    documentCreators.createUserPhoneVerificationBackoff,
  createUserQualityDetails: documentCreators.createUserQualityDetails,
  createUserRecentProjectsAndContests:
    documentCreators.createUserRecentProjectsAndContests,
  createUserRequiresGdpr: documentCreators.createUserRequiresGdpr,
  createUserRequiresPaymentVerification:
    documentCreators.createUserRequiresPaymentVerification,
  createUserRequiresPhoneVerification:
    documentCreators.createUserRequiresPhoneVerification,
  createUserSettings: documentCreators.createUserSettings,
  createUserSkills: documentCreators.createUserSkills,
  createUserTaxInfoObject: documentCreators.createUserTaxInfoObject,
  createUserTaxOptOutReasonObject:
    documentCreators.createUserTaxOptOutReasonObject,
  createUserVerificationProcesses:
    documentCreators.createUserVerificationProcesses,
  createUsers: documentCreators.createUsers,
  createUsersMfaObject: documentCreators.createUsersMfaObject,
  createUsersProfile: documentCreators.createUsersProfile,
  createUsersSelf: documentCreators.createUsersSelf,
  createVehicleTypes: documentCreators.createVehicleTypes,
  createVerificationAddressDocumentTypes:
    documentCreators.createVerificationAddressDocumentTypes,
  createVerificationCorporateKyc:
    documentCreators.createVerificationCorporateKyc,
  createVerificationFiles: documentCreators.createVerificationFiles,
  createVerificationIdTypes: documentCreators.createVerificationIdTypes,
  createVerificationProcessType: documentCreators.createVerificationProcessType,
  createVerificationProcessTypes:
    documentCreators.createVerificationProcessTypes,
  createVerificationRequest: documentCreators.createVerificationRequest,
  createVideoVerificationRequest:
    documentCreators.createVideoVerificationRequest,
  createVideochat: documentCreators.createVideochat,
  makeCollectionDelayed: documentCreators.makeCollectionDelayed,
  makeCollectionFailDelete: documentCreators.makeCollectionFailDelete,
  makeCollectionFailFetch: documentCreators.makeCollectionFailFetch,
  makeCollectionFailPush: documentCreators.makeCollectionFailPush,
  makeCollectionFailSet: documentCreators.makeCollectionFailSet,
  makeCollectionFailUpdate: documentCreators.makeCollectionFailUpdate,
  makeCollectionFailWhenEmpty: documentCreators.makeCollectionFailWhenEmpty,
  makeCollectionPending: documentCreators.makeCollectionPending,
  makeRequestFail: documentCreators.makeRequestFail,
  printRawDatastoreState: documentCreators.printRawDatastoreState,
  printState: documentCreators.printState,
  resetDatastoreState: documentCreators.resetDatastoreState,
  setAuth: documentCreators.setAuth,
  setDatastoreController: documentCreators.setDatastoreController,
  signup: documentCreators.signup,
  signupAndLogin: documentCreators.signupAndLogin,
  addAdminChargeUserFeeComputedFields:
    pushTransformers.addAdminChargeUserFeeComputedFields,
  addAdminEnterprisesComputedFields:
    pushTransformers.addAdminEnterprisesComputedFields,
  addAdminExternalCredentialAllocationComputedFields:
    pushTransformers.addAdminExternalCredentialAllocationComputedFields,
  addAdminPcbBanManagementComputedFields:
    pushTransformers.addAdminPcbBanManagementComputedFields,
  addAdminUserEnterprisesComputedFields:
    pushTransformers.addAdminUserEnterprisesComputedFields,
  addAgentSessionsComputedFields:
    pushTransformers.addAgentSessionsComputedFields,
  addAiChangeToneFields: pushTransformers.addAiChangeToneFields,
  addAiConsultantComputedFields: pushTransformers.addAiConsultantComputedFields,
  addAiPromptPreviewFields: pushTransformers.addAiPromptPreviewFields,
  addAiPrompts: pushTransformers.addAiPrompts,
  addBidDescriptionGenerationComputedFields:
    pushTransformers.addBidDescriptionGenerationComputedFields,
  addCanvasComputedFields: pushTransformers.addCanvasComputedFields,
  addCartApprovalComputedFields: pushTransformers.addCartApprovalComputedFields,
  addCategoryComputedFields: pushTransformers.addCategoryComputedFields,
  addCertificationComputedFields:
    pushTransformers.addCertificationComputedFields,
  addContactUsFields: pushTransformers.addContactUsFields,
  addContestCommentComputedFields:
    pushTransformers.addContestCommentComputedFields,
  addContestComputedFields: pushTransformers.addContestComputedFields,
  addContestEntriesFields: pushTransformers.addContestEntriesFields,
  addContestFilesComputedFields: pushTransformers.addContestFilesComputedFields,
  addContinueWritingFields: pushTransformers.addContinueWritingFields,
  addContractSigningUrlComputedFields:
    pushTransformers.addContractSigningUrlComputedFields,
  addCopilotEnquiryFields: pushTransformers.addCopilotEnquiryFields,
  addCustomBannerComputedFields: pushTransformers.addCustomBannerComputedFields,
  addDiscoverCollectionItem: pushTransformers.addDiscoverCollectionItem,
  addEducationComputedFields: pushTransformers.addEducationComputedFields,
  addEnterpriseContactComputedFields:
    pushTransformers.addEnterpriseContactComputedFields,
  addEnterprisesComputedFields: pushTransformers.addEnterprisesComputedFields,
  addExperienceComputedFields: pushTransformers.addExperienceComputedFields,
  addExternalReferenceFields: pushTransformers.addExternalReferenceFields,
  addFinancialReportingRecordComputedFields:
    pushTransformers.addFinancialReportingRecordComputedFields,
  addFreeRecruiterUpgradeComputedFields:
    pushTransformers.addFreeRecruiterUpgradeComputedFields,
  addGeneratedNumericalId: pushTransformers.addGeneratedNumericalId,
  addGeneratedStringId: pushTransformers.addGeneratedStringId,
  addGroupMember: pushTransformers.addGroupMember,
  addGroupsComputedFields: pushTransformers.addGroupsComputedFields,
  addHarvardContactFields: pushTransformers.addHarvardContactFields,
  addImproveWritingFields: pushTransformers.addImproveWritingFields,
  addInvitationBlockComputedFields:
    pushTransformers.addInvitationBlockComputedFields,
  addInvitationComputedFields: pushTransformers.addInvitationComputedFields,
  addIrisOffsitingMessageFields: pushTransformers.addIrisOffsitingMessageFields,
  addLoadPriceEstimateComputedFields:
    pushTransformers.addLoadPriceEstimateComputedFields,
  addMembershipRenewalsComputedFields:
    pushTransformers.addMembershipRenewalsComputedFields,
  addMilestoneDraftsComputedFields:
    pushTransformers.addMilestoneDraftsComputedFields,
  addNextProjectRecommendationsComputedFields:
    pushTransformers.addNextProjectRecommendationsComputedFields,
  addOnboardingEmailChangeComputedFields:
    pushTransformers.addOnboardingEmailChangeComputedFields,
  addPaymentShareInterestsComputedFields:
    pushTransformers.addPaymentShareInterestsComputedFields,
  addPaymentShareMemberComputedFields:
    pushTransformers.addPaymentShareMemberComputedFields,
  addPayoutAccount: pushTransformers.addPayoutAccount,
  addPayoutLimitExemptionComputedFields:
    pushTransformers.addPayoutLimitExemptionComputedFields,
  addPostJobPageDescriptionComputedFields:
    pushTransformers.addPostJobPageDescriptionComputedFields,
  addPostJobPageQuestionsComputedFields:
    pushTransformers.addPostJobPageQuestionsComputedFields,
  addPreferredSupportAgentFields:
    pushTransformers.addPreferredSupportAgentFields,
  addProfilesComputedFields: pushTransformers.addProfilesComputedFields,
  addProjectCollaborationComputedFields:
    pushTransformers.addProjectCollaborationComputedFields,
  addProjectDescriptionEntropyCompletionFields:
    pushTransformers.addProjectDescriptionEntropyCompletionFields,
  addProjectDescriptionEntropyQuestionFields:
    pushTransformers.addProjectDescriptionEntropyQuestionFields,
  addProjectDescriptionInsertionsFields:
    pushTransformers.addProjectDescriptionInsertionsFields,
  addProjectGroupComputedFields: pushTransformers.addProjectGroupComputedFields,
  addProjectOfferComputedFields: pushTransformers.addProjectOfferComputedFields,
  addProjectSkillsPredictionFields:
    pushTransformers.addProjectSkillsPredictionFields,
  addProjectTitleEditRequestComputedFields:
    pushTransformers.addProjectTitleEditRequestComputedFields,
  addProjectViewBidComputedFields:
    pushTransformers.addProjectViewBidComputedFields,
  addProjectViewProjectComputedFields:
    pushTransformers.addProjectViewProjectComputedFields,
  addProofreadFields: pushTransformers.addProofreadFields,
  addPublicationComputedFields: pushTransformers.addPublicationComputedFields,
  addPushTransformers: pushTransformers.addPushTransformers,
  addQuotationItemRevision: pushTransformers.addQuotationItemRevision,
  addQuotationLogoComputedFields:
    pushTransformers.addQuotationLogoComputedFields,
  addQuotationRevision: pushTransformers.addQuotationRevision,
  addRecommendedUpgradeComputedFields:
    pushTransformers.addRecommendedUpgradeComputedFields,
  addRecurringBillingInformationComputedFields:
    pushTransformers.addRecurringBillingInformationComputedFields,
  addRetellPhoneCallComputedFields:
    pushTransformers.addRetellPhoneCallComputedFields,
  addRetellProjectDetailsComputedFields:
    pushTransformers.addRetellProjectDetailsComputedFields,
  addRetellTokenComputedFields: pushTransformers.addRetellTokenComputedFields,
  addReviewComputedFields: pushTransformers.addReviewComputedFields,
  addSalesTaxComputedFields: pushTransformers.addSalesTaxComputedFields,
  addSavedSearchContextComputedFields:
    pushTransformers.addSavedSearchContextComputedFields,
  addSearchSavedFiltersComputedFields:
    pushTransformers.addSearchSavedFiltersComputedFields,
  addServiceOfferingAttachmentComputedFields:
    pushTransformers.addServiceOfferingAttachmentComputedFields,
  addServiceOfferingComputedFields:
    pushTransformers.addServiceOfferingComputedFields,
  addServiceOfferingShopCategoryComputedFields:
    pushTransformers.addServiceOfferingShopCategoryComputedFields,
  addServiceOfferingShopCategoryServiceFields:
    pushTransformers.addServiceOfferingShopCategoryServiceFields,
  addShowCaseComputedFields: pushTransformers.addShowCaseComputedFields,
  addSuperuserGroupsComputedFields:
    pushTransformers.addSuperuserGroupsComputedFields,
  addSupportAnswerFields: pushTransformers.addSupportAnswerFields,
  addSupportArticleFeedbacks: pushTransformers.addSupportArticleFeedbacks,
  addSupportChat: pushTransformers.addSupportChat,
  addSwiftIdApplicationComputedFields:
    pushTransformers.addSwiftIdApplicationComputedFields,
  addSwiftIdApplicationStatusComputedFields:
    pushTransformers.addSwiftIdApplicationStatusComputedFields,
  addSwiftIdInvitationComputedFields:
    pushTransformers.addSwiftIdInvitationComputedFields,
  addTaxStatementFields: pushTransformers.addTaxStatementFields,
  addUnconfirmedAwardsFields: pushTransformers.addUnconfirmedAwardsFields,
  addUserAvailabilityComputedFields:
    pushTransformers.addUserAvailabilityComputedFields,
  addUserConsentComputedFields: pushTransformers.addUserConsentComputedFields,
  addUserDocumentSubmissions: pushTransformers.addUserDocumentSubmissions,
  addUserNetPromoterScore: pushTransformers.addUserNetPromoterScore,
  addUserTaxInfoComputedFields: pushTransformers.addUserTaxInfoComputedFields,
  addUserVerificationProcesses: pushTransformers.addUserVerificationProcesses,
  addUsersRecommend: pushTransformers.addUsersRecommend,
  addVerificationRequestComputedFields:
    pushTransformers.addVerificationRequestComputedFields,
  noop: pushTransformers.noop,
};
